import styles from '../orders-page.module.scss'
import { observer } from 'mobx-react-lite'
import {
  TableContainer,
  TableHeader,
  TableBodyContainer,
  TableBodyLine,
  TableBodyLineProps,
  PaginationButtons,
  Button
} from '@touche-lts/panel-ui/dist'
// import { ProductSKUsDTO } from 'models/product-skus'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { OrdersDTO } from 'models'
import { OrdersTableSortProps, OrdersTableStatus, orderTableCellWidth } from 'mobx-stores/utils/orders-table-base/orders-table-base.types'
import { useGetScrollWidth } from 'hooks/custom-hooks'

const OrdersTableComponent = () => { 

  const {
    ordersStore: {
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect,
      triggerSearch,
      statusShown,
      statusTableHeader,
      handleSendOrderToShopify
    },
    ordersDetailsStore: {
      setOrderDetails
    },
    userStore: { assignedStore: store },
  } = useRootStore(),
  
  handleOrderDetailsPopup = (orderId: number): void => {
    setOrderDetails(true, orderId)
  }

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const { scrollX, handleScroll } = useGetScrollWidth()
  const spacebarSpacing = 4.8
  const getBodyLineCells = (
    order: OrdersDTO
  ): TableBodyLineProps['cells'] => {
    const cells: any = [
      {
        // widthPercentage: 100,
        widthPx : orderTableCellWidth.NUMBER,
        children: (
          <>
            #{order.number}
          </>
        ),
        onClick: () => handleOrderDetailsPopup(order.id),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.NUMBER)
      },
      {
        // widthPercentage: 100,
        widthPx : orderTableCellWidth.DATE,
        children: (
          <>
            {new Date(order.date).toLocaleDateString()} {new Date(order.date).toLocaleTimeString()}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.DATE)
      },
      {
        // widthPercentage: 100,
        widthPx : orderTableCellWidth.ORDERSTATUS,
        children: (
          <>
            <span className={styles[order?.store?.shopifyAccessToken && order?.store?.shopifyStoreUrl && order?.shopifyProcessStatus ? order?.shopifyProcessStatus  : order?.orderStatus]}></span> {statusShown(order?.store?.shopifyAccessToken && order?.store?.shopifyStoreUrl && order?.shopifyProcessStatus ? order?.shopifyProcessStatus  : order?.orderStatus)}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.ORDERSTATUS)
      },
      {
        // widthPercentage: 100,
        widthPx : orderTableCellWidth.TOTAL,
        children: (
          <>
            {order.price}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.TOTAL)
      },
      {
        // widthPercentage: 100,
        widthPx : orderTableCellWidth.CUSTOMER,
        children: (
          <>
            {order?.user?.firstName} {order?.user?.lastName}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.CUSTOMER)
      },
    ]

    if(order?.store?.shopifyAccessToken && order?.store?.shopifyStoreUrl){
      cells.push(
         {
          // widthPercentage: 100,
          widthPx : orderTableCellWidth.PLACEORDERTOSHOPIFY,
          children: (
            <>
              <Button preset='primary' onClick={() => handleSendOrderToShopify({store_id:order?.store?.id,number : order.number})} style={{width : 200}} disabled={order?.shopifyOrderId ? true : false }>
                   Place Order To Shopify
              </Button>
            </>
          ), // For Shopify integration
        }
      )
    }

    return cells
  },

  tableColumns: any = [
    {
      label: 'ORDER NUMBER',
      // widthPx: productsTableWidths.sku,
      isColumnMarked: isColumnMarked(OrdersTableSortProps.NUMBER),
      sortDirection: getSortDirection(OrdersTableSortProps.NUMBER),
      setSortDirection: handleSortDirectionChange(OrdersTableSortProps.NUMBER),
      inputProps: {
        placeholder: 'Search...',
        value: searchProps.number,
        type : "number",
        onChange: (number => onSearchPropsChange({ number }))
      },
      widthPx : orderTableCellWidth.NUMBER,
    },
    {
      label: 'ORDER DATE',
      isColumnMarked: isColumnMarked(OrdersTableSortProps.DATE),
      sortDirection: getSortDirection(OrdersTableSortProps.DATE),
      setSortDirection: handleSortDirectionChange(
        OrdersTableSortProps.DATE
      ),
      periodFilterProps: {
        period: searchProps.orderDate,
        setPeriod: orderDate => onSearchPropsChange({ orderDate }),
        className: styles.periodFilter
      },
      widthPx : orderTableCellWidth.DATE,
    },
    {
      label: 'STATUS',
      isColumnMarked: isColumnMarked(OrdersTableSortProps.ORDERSTATUS),
      sortDirection: getSortDirection(OrdersTableSortProps.ORDERSTATUS),
      setSortDirection: handleSortDirectionChange(
        OrdersTableSortProps.ORDERSTATUS
      ),
      selectProps: {
        noneLabel: 'All',
        options: statusTableHeader,
        value: searchProps.status,
        onChange: (status: OrdersTableStatus) => onSearchPropsChange({ status }),
      },
      widthPx : orderTableCellWidth.ORDERSTATUS,
    },
    {
        label: 'PURCHASE TOTAL',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.TOTAL),
        sortDirection: getSortDirection(OrdersTableSortProps.TOTAL),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.TOTAL
        ),
        sliderFilterProps: {
          label: 'order product',
          min: 0,
          max: 1000,
          value: [searchProps.minAmount, searchProps.maxAmount],
          onChange: ([minAmount, maxAmount]) =>
            onSearchPropsChange({ minAmount, maxAmount })
        },
        widthPx : orderTableCellWidth.TOTAL + spacebarSpacing,
      },
      {
        label: 'CUSTOMER',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.CUSTOMER),
        sortDirection: getSortDirection(OrdersTableSortProps.CUSTOMER),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.CUSTOMER
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.firstName,
          onChange: (firstName => onSearchPropsChange({ firstName }))
        },
        widthPx : orderTableCellWidth.CUSTOMER,
      },
  ]

  if (store?.shopifyAccessToken && store?.shopifyStoreUrl) {
    tableColumns.push({
      label: 'Place Order to Shopify',
      widthPx : orderTableCellWidth.PLACEORDERTOSHOPIFY,
    });
  }
  
  return (
    <TableContainer colorPreset='dark' style={{overflowX: 'auto'}} className={styles.thinScroll} onScroll={handleScroll}>
      <TableHeader colorPreset='dark' tableColumns={tableColumns} />
      <TableBodyContainer className={styles.tableBodyContainer}>
        {searchResults.map((order: OrdersDTO,id:number) => {
          return (
            <TableBodyLine colorPreset='dark' cells={getBodyLineCells(order)} key={id} containerProps={{className :styles.tableBodyLine}}/>
          )
        })}
      </TableBodyContainer>
      <PaginationButtons
        colorPreset='dark'
        alwaysShow
        {...paginationInfo}
        onPageSelect={onPageSelect}
        style={ {width: scrollX}}
      />
    </TableContainer>
  )
},

OrdersTable = observer(OrdersTableComponent)
export { OrdersTable }
